const lmz742 = [
    [
        -87.520848800000024,
        41.86284460000001
    ],
    [
        -87.506119100000021,
        41.840954800000013
    ],
    [
        -87.503970100000018,
        41.839518800000015
    ],
    [
        -87.496962400000015,
        41.829031100000016
    ],
    [
        -87.494042000000022,
        41.827299400000015
    ],
    [
        -87.486009500000023,
        41.820494800000013
    ],
    [
        -87.485042800000016,
        41.819866100000013
    ],
    [
        -87.48294180000002,
        41.817867100000015
    ],
    [
        -87.482364300000015,
        41.817025700000016
    ],
    [
        -87.481459100000009,
        41.816420800000017
    ],
    [
        -87.477976000000012,
        41.811208000000015
    ],
    [
        -87.471859100000017,
        41.807120800000014
    ],
    [
        -87.453806800000024,
        41.780103800000013
    ],
    [
        -87.45019120000002,
        41.765393200000013
    ],
    [
        -87.448784800000027,
        41.764718800000011
    ],
    [
        -87.434441000000021,
        41.766012200000013
    ],
    [
        -87.418108900000021,
        41.764395000000015
    ],
    [
        -87.412108900000021,
        41.763195000000017
    ],
    [
        -87.405039700000017,
        41.76104650000002
    ],
    [
        -87.525600400000016,
        41.733090900000022
    ],
    [
        -87.529509800000014,
        41.732304400000025
    ],
    [
        -87.528747500000009,
        41.733634900000027
    ],
    [
        -87.529846100000015,
        41.740634900000025
    ],
    [
        -87.539443900000009,
        41.740634900000025
    ],
    [
        -87.539545000000004,
        41.741034900000024
    ],
    [
        -87.536941499999998,
        41.741035400000023
    ],
    [
        -87.530145000000005,
        41.74153500000002
    ],
    [
        -87.530746399999998,
        41.748233400000018
    ],
    [
        -87.537147500000003,
        41.750835400000021
    ],
    [
        -87.542846600000004,
        41.752136200000024
    ],
    [
        -87.543946000000005,
        41.755135000000024
    ],
    [
        -87.541847200000007,
        41.756336200000021
    ],
    [
        -87.54034510000001,
        41.757534800000023
    ],
    [
        -87.543144200000015,
        41.760032600000024
    ],
    [
        -87.546653700000022,
        41.758731800000021
    ],
    [
        -87.547645500000016,
        41.758533400000019
    ],
    [
        -87.550646000000015,
        41.758934000000018
    ],
    [
        -87.553367600000016,
        41.760368300000017
    ],
    [
        -87.55484770000001,
        41.761959000000019
    ],
    [
        -87.555526700000016,
        41.761730100000015
    ],
    [
        -87.55754850000001,
        41.763134000000015
    ],
    [
        -87.559246000000016,
        41.765034000000014
    ],
    [
        -87.56064600000002,
        41.766033100000016
    ],
    [
        -87.559349300000022,
        41.769324700000013
    ],
    [
        -87.562647000000027,
        41.769534000000014
    ],
    [
        -87.565647000000027,
        41.774133900000017
    ],
    [
        -87.561764000000025,
        41.776400000000017
    ],
    [
        -87.562858500000019,
        41.780632000000018
    ],
    [
        -87.569046000000014,
        41.780532800000017
    ],
    [
        -87.571046900000013,
        41.78063400000002
    ],
    [
        -87.568848300000013,
        41.78143350000002
    ],
    [
        -87.576347300000009,
        41.786033600000017
    ],
    [
        -87.576583800000009,
        41.788139100000016
    ],
    [
        -87.577248000000012,
        41.788234000000017
    ],
    [
        -87.576548000000017,
        41.78833400000002
    ],
    [
        -87.575950600000013,
        41.788635200000023
    ],
    [
        -87.578548000000012,
        41.794134000000021
    ],
    [
        -87.576948000000016,
        41.795034000000022
    ],
    [
        -87.575851400000019,
        41.795135400000021
    ],
    [
        -87.574848000000017,
        41.795734000000017
    ],
    [
        -87.575248700000017,
        41.796932200000015
    ],
    [
        -87.577049200000019,
        41.796932200000015
    ],
    [
        -87.579448000000014,
        41.798434000000015
    ],
    [
        -87.580148000000008,
        41.799634000000012
    ],
    [
        -87.580148000000008,
        41.802534000000009
    ],
    [
        -87.579551600000002,
        41.803833000000012
    ],
    [
        -87.580947800000004,
        41.80433270000001
    ],
    [
        -87.586648000000011,
        41.81023290000001
    ],
    [
        -87.586649000000008,
        41.811533000000011
    ],
    [
        -87.590349000000003,
        41.81363300000001
    ],
    [
        -87.59224900000001,
        41.816933000000013
    ],
    [
        -87.597351000000003,
        41.823432900000014
    ],
    [
        -87.598548800000003,
        41.824432300000012
    ],
    [
        -87.598549000000006,
        41.82563300000001
    ],
    [
        -87.600549000000001,
        41.826833000000008
    ],
    [
        -87.601650000000006,
        41.829733000000004
    ],
    [
        -87.6025499,
        41.830533000000003
    ],
    [
        -87.602951000000004,
        41.831333100000002
    ],
    [
        -87.603349800000004,
        41.832932300000003
    ],
    [
        -87.6048507,
        41.833534200000003
    ],
    [
        -87.604553199999998,
        41.834831200000004
    ],
    [
        -87.609451199999995,
        41.845233900000004
    ],
    [
        -87.609352099999995,
        41.846233300000002
    ],
    [
        -87.611450099999999,
        41.850231100000002
    ],
    [
        -87.610849999999999,
        41.851433
    ],
    [
        -87.610849999999999,
        41.852832900000003
    ],
    [
        -87.611853800000006,
        41.855032400000006
    ],
    [
        -87.61210100000001,
        41.854983000000004
    ],
    [
        -87.612953100000013,
        41.855632700000001
    ],
    [
        -87.612953100000013,
        41.857032699999998
    ],
    [
        -87.612251200000017,
        41.8585323
    ],
    [
        -87.612503000000018,
        41.860984799999997
    ],
    [
        -87.612651000000014,
        41.865232999999996
    ],
    [
        -87.61245120000001,
        41.865234299999997
    ],
    [
        -87.612551000000011,
        41.865732999999999
    ],
    [
        -87.610549900000009,
        41.865734099999997
    ],
    [
        -87.610649100000003,
        41.865234299999997
    ],
    [
        -87.610500999999999,
        41.865232999999996
    ],
    [
        -87.609848,
        41.862331299999994
    ],
    [
        -87.610350999999994,
        41.861332999999995
    ],
    [
        -87.610450700000001,
        41.859233799999991
    ],
    [
        -87.610050999999999,
        41.858582999999989
    ],
    [
        -87.610050999999999,
        41.857735899999987
    ],
    [
        -87.609298699999997,
        41.856532999999985
    ],
    [
        -87.609450999999993,
        41.856432999999981
    ],
    [
        -87.609748799999991,
        41.853534599999982
    ],
    [
        -87.608749299999985,
        41.853134099999984
    ],
    [
        -87.606353699999985,
        41.853233299999985
    ],
    [
        -87.606850999999992,
        41.859932999999984
    ],
    [
        -87.60595099999999,
        41.860332999999983
    ],
    [
        -87.606050899999985,
        41.862032899999981
    ],
    [
        -87.606353699999985,
        41.861934599999984
    ],
    [
        -87.607063799999992,
        41.863215899999986
    ],
    [
        -87.518624399999993,
        41.874459299999984
    ],
    [
        -87.520848800000024,
        41.86284460000001
    ]
];

export default lmz742;
